import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' as const });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`fixed bottom-40 md:bottom-24 right-4 md:right-6 z-20 w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg cursor-pointer transition-all duration-300 hover:bg-primary-600 hover:scale-110 active:scale-95 whitespace-nowrap ${
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <div className="w-4 h-4 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg"></i>
      </div>
    </button>
  );
}